// v-action: make a non-button element (div, span, img, ion-icon, …) behave like a button
// for keyboard users. It adds role="button" and tabindex (unless the element already sets
// them) and triggers the element's own click handler on Enter/Space — mirroring native
// button behaviour. Use it on elements that already have an @click handler.
//
// For elements with a disabled/selected state, bind the relevant attributes yourself, e.g.
//   :tabindex="selectable ? 0 : -1" :aria-disabled="selectable ? null : 'true'"
//   :aria-pressed="selected ? 'true' : 'false'"
// The handler below respects aria-disabled and will not activate a disabled element.

function onActionKeydown(event) {
  const el = event.currentTarget
  if (el.getAttribute("aria-disabled") === "true") {
    return
  }
  if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
    // Space would otherwise scroll the page; Enter/Space both activate, like a real button
    event.preventDefault()
    el.click()
  }
}

export const actionDirective = {
  mounted(el) {
    if (!el.hasAttribute("role")) {
      el.setAttribute("role", "button")
    }
    if (!el.hasAttribute("tabindex")) {
      el.setAttribute("tabindex", "0")
    }
    el.addEventListener("keydown", onActionKeydown)
  },
  unmounted(el) {
    el.removeEventListener("keydown", onActionKeydown)
  },
}
